import { type ApolloError, gql, useQuery } from '@apollo/client';
import type { Country, QueryCountriesWithFilterArgs } from '@/types/GraphqlSchema';

const QUERY = gql`
  query countriesWithFilter(
    $companies: [String!]
    $assets: [JSON!]
    $basins: [String!]
    $nonOperator: Boolean
    $operator: Boolean
    $hasAssets: Boolean
    $hasBlocks: Boolean
    $hasLeases: Boolean
    $hasGhgEmissions: Boolean
    $hasMaTransactions: Boolean
    $hasNonModelledProduction: Boolean
    $includeHistoricalParticipants: Boolean
    $sortBy: String
    $feature: String
  ) {
    countriesWithFilter(
      companies: $companies
      assets: $assets
      basins: $basins
      nonOperator: $nonOperator
      operator: $operator
      hasAssets: $hasAssets
      hasBlocks: $hasBlocks
      hasLeases: $hasLeases
      hasGhgEmissions: $hasGhgEmissions
      hasMaTransactions: $hasMaTransactions
      hasNonModelledProduction: $hasNonModelledProduction
      includeHistoricalParticipants: $includeHistoricalParticipants
      sortBy: $sortBy
      feature: $feature
    ) {
      id
      displayName
      name
      isoCode
      geom
      region {
        id
        name
        displayName
      }
    }
  }
`;

type UseGetCountriesWithFiltersProps = {
  skip?: boolean;
  variables?: QueryCountriesWithFilterArgs;
};

type UseGetCountriesWithFiltersReturn = {
  countries: Country[];
  loading: boolean;
  error?: ApolloError | undefined;
};

export const useGetCountriesWithFilters = ({
  variables = {},
  skip = false,
}: UseGetCountriesWithFiltersProps): UseGetCountriesWithFiltersReturn => {
  const { data, loading, error } = useQuery(QUERY, { skip, variables });

  return {
    countries: data?.countriesWithFilter || [],
    loading,
    error,
  };
};
